import React, {useState, useEffect} from 'react';

import {useTranslation} from "react-i18next";
import {Modal} from 'react-bootstrap'
import Auxiliary from "../../hoc/Auxiliary";

const ModalMxo = (props) => {
    const {t} = useTranslation();
    const [show, setShow] = useState(false);
    const showCloseButton = (props.showCloseButton != null && props.showCloseButton != undefined) ? props.showCloseButton : true;
    const closeButtonClass = props.closeButtonClass ? props.closeButtonClass : 'btn btn--raised btn--raised--red btn--fs-12';
    const closeButtonText = props.closeButtonText ? props.closeButtonText : t("popup.close");

    useEffect(() => {
        //if(props.show != null) setShow(props.show);
    }, [show])

    return (
        <Auxiliary>
                <Auxiliary>
                    <Modal show={props.show}
                           onShow={props.onShow}
                           onHide={props.onHide}
                           backdrop={props.backDrop}
                           keyboard={true}
						   className={props.modalClass}
						   animation={false}
                           dialogClassName={`ultimate-modal ${props.footerActions !== "" ? '': 'ultimate-modal--large'} ${props.extrasClass}`}
                    >
                        <Modal.Header closeButton={showCloseButton}>
                            <h3 className="headline headline--c-white headline--block headline--margin--0 text-uppercase headline--weight--extra-bold headline--fs-22">
                                {props.title}
                            </h3>
                        </Modal.Header>
                        <Modal.Body id={'modalBody'} style={{ maxHeight: props.footerActions !== "" ? '70vh': ''}}>
                            {props.children}
                        </Modal.Body>
                        {
                            !props.hideFooter ?  <Modal.Footer>
                                {(showCloseButton) ?
                                    <button className={closeButtonClass}
                                        onClick={props.onHide}>
                                        {closeButtonText}
                                    </button>
                                    : null
                                }
                            </Modal.Footer> : null
                        }
                        {
                            props.footerActions !== "" && <React.Fragment>
                                {props.footerActions}
                            </React.Fragment>
                        }

                    </Modal>
                </Auxiliary>
        </Auxiliary>
    );
}

export default ModalMxo;
